import { nanoid } from "nanoid";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, customerReqConfig } from "../../include/api";
import { ERROR, SUCCESS, EDIT, ADD } from "../../include/constant";
import {
  discountValue,
  emptyCart,
  getCheckout,
  getCustomer,
  isEmptyObj,
  preventClick,
} from "../../include/function";
import { useNotification } from "../../Toast/ToastProvider";
import Error from "../add-ons/Error";
import Spinner from "../add-ons/Spinner";
import { useCart } from "../context/UserCartCountContext";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/Checkout.css";
import AddressForm from "../common/AddressForm";

const CustomerCheckout = () => {
  const { flag } = useParams();
  const user = getCustomer();
  const navigate = useNavigate();
  const toast = useNotification();
  const { fetchCartCount } = useCart();
  const customer = getCustomer();
  const [fetchLoading, setFetchLoading] = useState(true);
  const [placeOrderLoading, setPlaceOrderLoading] = useState(false);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [voucherVerified, setVoucherVerified] = useState(false);

  const [placeOrderData, setPlaceOrderData] = useState([]);
  const [voucherData, setVoucherData] = useState({});
  const [addressList, setAddressList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(0);
  const [save, setSave] = useState(0);

  const [voucher, setVoucher] = useState("");
  const [selectedAddressError, setSelectedAddressError] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [selectedPaymentError, setSelectedPaymentError] = useState("");
  const [selectedShipping, setSelectedShipping] = useState("");
  const [selectedShippingError, setSelectedShippingError] = useState("");
  const [voucherDiscountAmount, setVoucherDiscountAmount] = useState("");
  const [sameAsDelivery, setSameAsDelivery] = useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(0);
  const [gstNumber, setGstNumber] = useState("");

  const [includeGst, setIncludeGst] = useState(false);

  const [settings, setSettings] = useState([]);

  const [product, setProduct] = useState({});

  const [products, setProducts] = useState([]);

  const [editType, setEditType] = useState("");
  const [editAddressId, setEditAddressId] = useState("");
  const [formContext, setFormContext] = useState(null);

  const handleBillingType = (type, id) => {
    setFormContext({ mode: type, addressType: "billing", addressId: id });
  };
  const handleDeliveryType = (type, id) => {
    setFormContext({ mode: type, addressType: "delivery", addressId: id });
  };

  console.log('selectedDel', selectedAddress);
  console.log('selectedBill', selectedBillingAddress);


  const handleType = (type, id) => {
    setEditType(type);
    setType(type);
    if (type === EDIT) setEditAddressId(id);
  };

  useEffect(() => {
    const checkout = getCheckout();

    if (!isEmptyObj(checkout)) setPlaceOrderData(checkout);
    else {
      navigate("/checkout");
    }
  }, [flag, navigate]);

  useEffect(() => getAddress(user.id), [user.id]);

  useEffect(() => {
    if (addressList.length > 0) setSelectedAddress(addressList[0].id);
  }, [addressList]);

  useEffect(() => {
    if (voucherVerified && !isEmptyObj(voucherData)) {
      const voucherDiscountAmount = discountValue(
        Number(placeOrderData.billAmount) -
        Number(placeOrderData.totalDiscount),
        voucherData.value,
        voucherData.mode
      );
      setVoucherDiscountAmount(voucherDiscountAmount);
    }
  }, [
    placeOrderData.billAmount,
    placeOrderData.totalDiscount,
    voucherData,
    voucherVerified,
  ]);

  useEffect(() => {
    if (voucherVerified) {
      setPlaceOrderData((prev) => ({
        ...prev,
        voucherCode: voucherData.code,
        voucherText: voucher + " - " + voucherData.text,
        voucherMode: voucherData.mode,
        voucherValue: voucherData.value,
        voucherDiscountAmount: voucherDiscountAmount,
        totalAmount:
          prev.billAmount +
          prev.totalDeliveryCharge -
          (prev.totalDiscount + voucherDiscountAmount),
      }));
    }
  }, [
    voucherData.code,
    voucherData.mode,
    voucherData.text,
    voucherData.value,
    voucherDiscountAmount,
    voucherVerified,
    voucher,
  ]);

  useEffect(() => {
    setSave(
      Math.round(
        Number(voucherDiscountAmount) + Number(placeOrderData.totalDiscount)
      )
    );
  }, [placeOrderData.totalDiscount, voucherDiscountAmount]);

  useEffect(() => {
    if (selectedPayment !== "") {
      placeOrderData.orderItems?.forEach((item) => {
        item.paymentMode = selectedPayment;
        item.paymentStatus = "Pending";
        item.paymentInfo = selectedPayment;
      });
    }
  }, [placeOrderData.orderItems, selectedPayment]);

  useEffect(() => {
    if (orderPlaced) {
      navigate("/orderPlaced");
      fetchCartCount();
    }
  }, [orderPlaced, navigate]);

  const getAddress = (id) => {
    setFetchLoading(true);
    api
      .get("/customer_address/?customerId=" + id, customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setAddressList(response.data.data);
        }
      })
      .catch((error) => {
        setAddressList([]);
      })
      .finally(() => setFetchLoading(false));
  };

  const handleSelectAddress = (value) => {
    setSelectedAddressError("");
    setSelectedAddress(value);
  };
  const handleSelectBillingAddress = (value) => {
    setSelectedBillingAddress(value);
  };
  const handleSelectPayment = (value) => {
    setSelectedPaymentError("");
    setSelectedPayment(value);
  };

  const handleSelectShipping = (value, amt) => {
    setSelectedShippingError("");
    setSelectedShipping(value);
    if (value !== "") {
      placeOrderData.totalDeliveryCharge = amt;
      placeOrderData.totalAmount =
        placeOrderData.billAmount +
        amt -
        (placeOrderData.totalDiscount + voucherDiscountAmount);
    }
  };

  useEffect(() => {
    api
      .get("/settings/", customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setSettings(response.data.data);
        }
      })
      .catch((error) => {
        setSettings([]);
      })
      .finally();
  }, []);

  const deleteCartAfterCheckout = () => {
    api
      .delete("/cart/?customerId=" + user.id, customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
        }
      })
      .catch((error) => {
        error.response
          ? toast({ type: ERROR, message: error.response.data.message })
          : toast({ type: ERROR, message: error.message });
      })
      .finally();
  };

  const handleContinue = () => {
    let error = false;

    if (selectedAddress <= 0 || selectedAddress === "") {
      // setSelectedAddressError("Select an address");
      toast({ type: ERROR, message: "Please select a delivery address" });
      error = true;
    }
    if (selectedPayment === "") {
      setSelectedPaymentError("Select a payment method");
      toast({ type: ERROR, message: "Please select a payment method" });
      error = true;
    }
    if (selectedShipping === "") {
      setSelectedShippingError("Select a shipping method");
      toast({ type: ERROR, message: "Please select a shipping method" });
      error = true;
    }

    if (!error) {
      const addressIndex = addressList?.findIndex(
        (al) => String(al.id) === String(selectedAddress)
      );
      if (addressIndex >= 0) {
        const address = addressList[addressIndex];

        placeOrderData.customerId = user.id;
        placeOrderData.name = address.name;
        placeOrderData.phoneNumber = address.phoneNumber;
        placeOrderData.alternatePhoneNumber = address.alternatePhoneNumber;
        placeOrderData.locality = address.locality;
        placeOrderData.address = address.address;
        placeOrderData.city = address.city;
        placeOrderData.state = address.state;
        placeOrderData.landmark = address.landmark;
        placeOrderData.pin = address.pin;
        placeOrderData.addressType = address.addressType;

        placeOrderData.customerType = user.customerType;

        setPlaceOrderLoading(true);
        api
          .post("/orders/", placeOrderData, customerReqConfig())
          .then((response) => {
            if (response.status === 200) {
              if (!placeOrderData.isBuyNow) {
                // ✅ Only clear cart for normal checkout
                emptyCart();
                deleteCartAfterCheckout();
              }
              toast({ type: SUCCESS, message: response.data.message });
              setOrderPlaced(true);
            }
          })
          .catch((error) => {
            error.response
              ? toast({ type: ERROR, message: error.response.data.message })
              : toast({ type: ERROR, message: error.message });
          })
          .finally(() => setPlaceOrderLoading(false));
      }
    }
  };

  const getProductById = (productId) => {
    api
      .get(`/product/?idArray=[${productId}]`, customerReqConfig())
      .then((response) => {
        if (response.status === 200 && response.data.data.length > 0) {
          setProduct(response.data.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });
  };

  const getProductsByIds = (idArray) => {
    if (!idArray || idArray.length === 0) return;

    api
      .get(`/product/?idArray=[${idArray.join(",")}]`, customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setProducts(response.data.data); // list of product objects
        }
      })
      .catch((error) => {
        console.error("Product fetch error:", error);
      });
  };

  useEffect(() => {
    if (placeOrderData.orderItems && placeOrderData.orderItems.length > 0) {
      const ids = placeOrderData.orderItems.map((item) => item.productId);
      getProductsByIds(ids);
    }
  }, [placeOrderData]);

  useEffect(() => {
    if (placeOrderData.orderItems && placeOrderData.orderItems.length > 0) {
      const firstProductId = placeOrderData.orderItems[0].productId;
      getProductById(firstProductId);
    }
  }, [placeOrderData]);

  const [type, setType] = useState("");
  const [id, setId] = useState("");

  // const onSave = (data) => {
  //   if (type === ADD) {
  //     setAddressList((prev) => [...prev, data]);
  //   } else if (type === EDIT) {
  //     setAddressList((prev) => {
  //       prev.slice();
  //       const index = prev.findIndex((a) => a.id === id);
  //       prev[index] = data;
  //       return prev;
  //     });
  //   }
  //   setType("");
  //   setId("");
  // };

  const onSave = (data) => {
    setAddressList((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((a) => String(a.id) === String(data.id));
      if (index !== -1) {
        updated[index] = { ...data };
      } else {
        updated.push(data);
      }
      return updated;
    });

    if (String(selectedAddress) === String(data.id)) {
      setSelectedAddress(data.id);
    }

    setFormContext(null);
  };
  // const onCancel = () => {
  //   setType("");
  //   setId("");
  // };
  const onCancel = () => {
    setFormContext(null);
  };
  const safeFloat = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? 0 : num;
  };
  const totalMRP =
    placeOrderData.orderItems?.reduce((sum, item) => {
      const price = parseInt(item.price || 0);
      const qty = parseInt(item.qty || 1);
      return sum + price * qty;
    }, 0) || 0;

  // const discount =
  //   placeOrderData.orderItems?.reduce((sum, item) => {
  //     let d = 0;
  //     if (item.discountMode === "percent") {
  //       d = Math.round(
  //         (safeFloat(item.discountValue) / 100) *
  //         safeFloat(item.price) *
  //         parseInt(item.qty || 1)
  //       );
  //     } else if (item.discountMode === "amount") {
  //       d = Math.round(safeFloat(item.discountValue) * parseInt(item.qty || 1));
  //     }
  //     return sum + d;
  //   }, 0) || 0;
  
    const b2bDiscount = placeOrderData.orderItems?.reduce((sum, item) => {
      let d = 0;
      if (item.b2bDiscountMode === "percent") {
        d = Math.round(
          (safeFloat(item.b2bDiscountValue) / 100) *
            safeFloat(item.price) *
            parseInt(item.qty || 1)
        );
      } else if (item.b2bDiscountMode === "amount") {
        d = Math.round(
          safeFloat(item.b2bDiscountValue) * parseInt(item.qty || 1)
        );
      }
      return sum + d;
    }, 0);
    const b2cDiscount = placeOrderData.orderItems?.reduce((sum, item) => {
      let d = 0;
      if (item.b2cDiscountMode === "percent") {
        d = Math.round(
          (safeFloat(item.b2cDiscountValue) / 100) *
            safeFloat(item.price) *
            parseInt(item.qty || 1)
        );
      } else if (item.b2cDiscountMode === "amount") {
        d = Math.round(
          safeFloat(item.b2cDiscountValue) * parseInt(item.qty || 1)
        );
      }
      return sum + d;
    }, 0);

const discount =
  !customer || customer.customerType === "individual"
    ? b2cDiscount || 0
    : b2bDiscount || 0;
const grandTotal = totalMRP - discount;
  return (
    <div className="">
      <div
        className="checkout-steps d-flex justify-content-center align-items-center mb-4 pb-48 px-80"
        style={{
          marginTop: "200px",
        }}
      >
        <div className="step active">1</div>
        <div className="word">Cart</div>
        <div className="line active"></div>
        <div className="step active">2</div>
        <div className="word">Address</div>
        <div className="line"></div>
        <div className="step ">3</div>
        <div>Order Summary</div>
        <div className="line"></div>
        <div className="step">4</div>
        <div>Payment</div>
      </div>
      <div className="container-fluid my-3">
        <div className="row">
          <div className="col-xl-9 col-lg-6">
            <div
              className={`mb-4${selectedAddressError === "" ? "" : "border-danger"
                }`}
            >
              <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                <div className="d-flex justify-content-between align-items-center ">
                  <h6 className="text-dark fs-4">Delivery Address</h6>
                  <h6 className="text-dark fs-5">
                    {
                      addressList.filter(
                        (addr) =>
                          (addr.addressType === "home") |
                          (addr.addressType === "work")
                      ).length
                    }{" "}
                    Addresses
                  </h6>
                </div>
                {addressList
                  .filter(
                    (addr) =>
                      (addr.addressType === "home") |
                      (addr.addressType === "work")
                  )
                  .map((address, index) => {
                    const isSelected =
                      String(selectedAddress) === String(address.id);

                    return formContext?.mode === EDIT &&
                      formContext?.addressId === address.id ? (
                      <AddressForm
                        id={formContext.addressId}
                        reqConfig={customerReqConfig()}
                        title="Edit Address"
                        type={EDIT}
                        userId={user.id}
                        editAddress={address}
                        onSave={onSave}
                        onCancel={onCancel}
                      />
                    ) : (
                      <div
                        key={nanoid()}
                        onClick={() => handleSelectAddress(address.id)}
                        className="position-relative"
                      >
                        <div className="w-100 p-10">
                          <div className="">
                            <div
                              className={`address-card1 d-flex justify-content-between align-items-start gap-10 p-16  rounded-8 ${String(selectedAddress) === String(address.id)
                                ? "selected "
                                : "border border-gray-100"
                                }`}
                            >
                              <div className="d-flex align-items-start gap-12">
                                <div
                                  className="bg-gray-100 p-2 rounded-8 d-flex justify-content-center align-items-center"
                                  style={{ width: "90px", height: "90px" }}
                                >
                                  {address.addressType === "home" ? (
                                    <i
                                      className="ph ph-house"
                                      style={{ fontSize: "60px" }}
                                    />
                                  ) : (
                                    <i
                                      className="ph ph-buildings"
                                      style={{ fontSize: "60px" }}
                                    />
                                  )}
                                </div>
                                <div>
                                  <div
                                    style={{ width: "450px", textWrap: "wrap" }}
                                  >
                                    <div className="text-uppercase small fw-bold mt-2 me-3 text-nowrap">
                                      <span className="text-black">
                                        {address.addressType}
                                      </span>
                                    </div>
                                    <p className="mb-1">{address.address}</p>
                                    <p className="mb-0">
                                      {address.locality}, {address.city},{" "}
                                      {address.state} - {address.pin}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className="btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8"
                                  onClick={(e) =>
                                    preventClick(e, () =>
                                      handleDeliveryType(EDIT, address.id)
                                    )
                                  }
                                >
                                  Edit
                                </Link>
                                {/* Radio button */}
                                <div
                                  className={`radio-indicator  ${String(selectedAddress) ===
                                    String(address.id)
                                    ? "selected-radio"
                                    : ""
                                    }`}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                {/* Show add address form if triggered */}
                {formContext?.mode === ADD &&
                  formContext?.addressType === "delivery" ? (
                  <div className="mt-4">
                    <AddressForm
                      reqConfig={customerReqConfig()}
                      type={ADD}
                      userId={user.id}
                      title="Add Address"
                      onSave={onSave}
                      onCancel={onCancel}
                    />
                  </div>
                ) : (
                  <div className="w-100 p-10">
                    <div className="py-18 bg-gray-50 rounded-8 text-center">
                      <Link
                        to="#"
                        className="text-dark text-sm fw-semibold hover-text-decoration-underline"
                        onClick={(e) =>
                          preventClick(e, () =>
                            setFormContext({
                              mode: ADD,
                              addressType: "delivery",
                            })
                          )
                        }
                      >
                        <i className="fa fa-plus me-8" />
                        <span>Add new delivery Address</span>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`mb-4${selectedAddressError === "" ? "" : "border-danger"
                }`}
            >
              <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                <div className="d-flex justify-content-between align-items-center ">
                  <h6 className="text-dark fs-4">Billing Address</h6>
                  <h6 className="text-dark fs-5">
                    {
                      addressList.filter(
                        (addr) => addr.addressType === "billing"
                      ).length
                    }{" "}
                    Addresses
                  </h6>
                </div>
                {addressList
                  .filter((addr) => addr.addressType === "billing")
                  .map((address, index) => {
                    const isSelected =
                      String(selectedAddress) === String(address.id);

                    return formContext?.mode === EDIT &&
                      formContext?.addressId === address.id ? (
                      <AddressForm
                        id={formContext.addressId}
                        reqConfig={customerReqConfig()}
                        title="Edit Billinig Address"
                        type={EDIT}
                        userId={user.id}
                        editAddress={address}
                        forceAddressType="billing"
                        showGstField={true}
                        // onSave={(data) => {
                        //   setAddressList((prev) => {
                        //     const updated = [...prev];
                        //     const index = updated.findIndex(
                        //       (a) => a.id === data.id
                        //     );
                        //     if (index !== -1) updated[index] = data;
                        //     return updated;
                        //   });
                        //   setEditType("");
                        //   setEditAddressId("");
                        // }}
                        // onCancel={() => {
                        //   setEditType("");
                        //   setEditAddressId("");
                        // }}
                        onSave={onSave}
                        onCancel={onCancel}
                      />
                    ) : (
                      <div
                        key={nanoid()}
                        onClick={() =>
                          !sameAsDelivery &&
                          handleSelectBillingAddress(address.id)
                        }
                        className={`position-relative ${sameAsDelivery ? "disabled-address" : ""
                          }`}
                      >
                        <div className="w-100 p-10">
                          <div className="">
                            <div
                              className={`address-card1 d-flex justify-content-between align-items-start gap-10 p-16 rounded-8 ${
                                String(selectedBillingAddress) ===
                                String(address.id)
                                  ? "selected"
                                  : "border border-gray-100"
                              } ${sameAsDelivery ? "disabled-address" : ""}`}
                            >
                              <div className="d-flex align-items-start gap-12">
                                <div
                                  className="bg-gray-100 p-2 rounded-8 d-flex justify-content-center align-items-center"
                                  style={{ width: "90px", height: "90px" }}
                                >
                                  {address.addressType === "home" ? (
                                    <i
                                      className="ph ph-house"
                                      style={{ fontSize: "60px" }}
                                    />
                                  ) : (
                                    <i
                                      className="ph ph-buildings"
                                      style={{ fontSize: "60px" }}
                                    />
                                  )}
                                </div>
                                <div>
                                  <div
                                    style={{ width: "450px", textWrap: "wrap" }}
                                  >
                                    <div className="text-uppercase small fw-bold mt-2 me-3 text-nowrap">
                                      <span className="text-black">
                                        {address.addressType}
                                      </span>
                                    </div>
                                    <p>GSTNIN{address.gstNo}</p>
                                    <p className="mb-1">{address.address}</p>
                                    <p className="mb-0">
                                      {address.locality}, {address.city},{" "}
                                      {address.state} - {address.pin}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex align-items-center gap-2">
                                <Link
                                  to="#"
                                  className="btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8"
                                  onClick={(e) =>
                                    preventClick(e, () =>
                                      handleBillingType(EDIT, address.id)
                                    )
                                  }
                                >
                                  Edit
                                </Link>
                                {/* Radio button */}
                                <div
                                  className={`radio-indicator  ${String(selectedBillingAddress) ===
                                    String(address.id)
                                    ? "selected-radio"
                                    : ""
                                    }`}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                {formContext?.mode === ADD &&
                  formContext?.addressType === "billing" ? (
                  <div className="mt-4">
                    <AddressForm
                      reqConfig={customerReqConfig()}
                      type={ADD}
                      userId={user.id}
                      title="Add Address"
                      forceAddressType="billing"
                      showGstField={true}
                      onSave={onSave}
                      onCancel={onCancel}
                    />
                  </div>
                ) : (
                  <div className="w-100 p-10">
                    <div className="py-18 bg-gray-50 rounded-8 text-center">
                      <Link
                        to="#"
                        className={`text-dark text-sm fw-semibold hover-text-decoration-underline ${sameAsDelivery ? "disabled-btn" : ""
                          }`}
                        onClick={(e) =>
                          preventClick(e, () =>
                            setFormContext({
                              mode: ADD,
                              addressType: "billing",
                            })
                          )
                        }
                      >
                        <i className="fa fa-plus me-8" />
                        <span>Add new billing Address</span>
                      </Link>
                    </div>
                  </div>
                )}
                <div className="w-100 p-10">
                  <input
                    type="checkbox"
                    className="same-as-checkbox"
                    id="sameAsAddress"
                    checked={sameAsDelivery}
                    onChange={(e) => {
                      setSameAsDelivery(e.target.checked);

                      if (e.target.checked) {
                        const deliveryAddr = addressList.find(
                          (addr) => addr.addressType !== "billing"
                        );
                        if (deliveryAddr)
                          setSelectedBillingAddress(deliveryAddr.id);
                      }
                    }}
                  />
                  <label
                    className="text-dark fw-bold fs-6 ms-10 small"
                    htmlFor="sameAsAddress"
                  >
                    Same as delivery address
                  </label>
                </div>
                <div className="w-100 p-10">
                  <div className="d-flex flex-column  gap-3 p-16 rounded-8 border border-gray-100">
                    <h6 className="text-dark fw-bold">GST Invoice</h6>

                    {/* Input + Add button */}
                    <div className="d-flex gap-16">
                      <input
                        type="text"
                        className="form-control gst-input-field"
                        placeholder="Enter GST Number"
                        value={gstNumber}
                        onChange={(e) => setGstNumber(e.target.value)}
                        disabled={!includeGst}
                      />
                      <button
                        className={`btn btn-sm rounded-5 px-28  ${
                          includeGst ? "btn-main-gst" : "btn-main-gst"
                        }`}
                        disabled={!includeGst}
                      >
                        Add
                      </button>
                    </div>

                    {/* Checkbox */}
                    <div className="d-flex align-items-center gap-2 mt-20">
                      <input
                        type="checkbox"
                        id="includeGst"
                        checked={includeGst}
                        onChange={(e) => setIncludeGst(e.target.checked)}
                        className="same-as-checkbox"
                        style={{ width: "16px", height: "16px" }}
                      />
                      <label
                        className=" text-dark fw-bold fs-6 ms-10 small"
                        htmlFor="includeGst"
                      >
                        Include GST in invoice
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-4">
              <div className="d-flex justify-content-end">
                {/* <button
                  className="btn btn-main btn-sm mt-14 px-48 rounded-5"
                  onClick={() => {
                    const selectedAddr = addressList.find(
                      (addr) => String(addr.id) === String(selectedAddress)
                    );
                    if (selectedAddr) {
                      navigate("/order-summary", {
                        state: { selectedAddress: selectedAddr },
                      });
                    } else {
                      toast({
                        type: ERROR,
                        message: "Please select a valid address",
                      });
                    }
                  }}
                >
                  Continue
                </button> */}
                <button
                  className="btn btn-main btn-sm mt-14 px-48 rounded-5"
                  onClick={() => {
                    const deliveryAddr = addressList.find(
                      (addr) => String(addr.id) === String(selectedAddress)
                    );
                    const billingAddr = addressList.find(
                      (addr) =>
                        String(addr.id) === String(selectedBillingAddress)
                    );

                    localStorage.setItem(
                      "orderAddresses",
                      JSON.stringify({
                        deliveryAddress: deliveryAddr,
                        billingAddress: billingAddr,
                        gstNumber: includeGst ? gstNumber : "",
                      })
                    );

                    // navigate("/order-summary", {
                    //   state: {
                    //     deliveryAddress: deliveryAddr,
                    //     billingAddress: billingAddr,
                    //     gstNumber: includeGst ? gstNumber : "",
                    //   },
                    // });
                    navigate("/order-summary");
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-lg-4">
            <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40 mt-24">
              <h6 className="text-xl mb-32">PRICE DETAILS</h6>
              <div className="bg-color-three rounded-8 p-24">
                <div className="mb-32 flex-between gap-8">
                  <span className="text-dark fw-bol">
                    {`Price (${placeOrderData.orderItems?.length || 0}) items`}
                  </span>
                  <span className="text-gray-900 fw-semibold">
                    ₹ {totalMRP.toFixed(2)}
                  </span>
                  {/* <span className="text-gray-900 font-heading-two">
                        Total M.R.P
                      </span>
                      <span className="text-gray-900 fw-semibold">
                        ₹ {totalMRP.toFixed(2)}
                      </span> */}
                </div>
                <div className="mb-32 flex-between gap-8">
                  <span className="text-dark">Discount</span>
                  <span className="text-gray-900 fw-semibold">
                    - ₹ {discount.toFixed(2)}
                  </span>
                </div>
                <div className="mb-32 flex-between gap-8">
                  <span className="text-dark">Coupon Discount</span>
                  <span className="text-gray-900 fw-semibold">
                    {/* - ₹ {discount.toFixed(2)} */}- ₹ 0.00
                  </span>
                </div>
              </div>
              <div className="bg-color-three rounded-8 p-24 mt-24">
                <div className="flex-between gap-8">
                  <span className="text-gray-900 text-xl fw-bold">Total</span>
                  <span className="text-gray-900 text-xl fw-bold">
                    ₹ {grandTotal.toFixed(2)}
                  </span>
                </div>
              </div>
              <div className="mt-68">
                You will save ₹ {discount} on this order
              </div>
            </div>
            <div className="mt-16 ms-16">
              Your personal data will be used to process your order, support
              your experience throughout this website, and for other purpose
              described in our{" "}
              <a style={{ color: "#ff6600" }}>Privacy policy</a> .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCheckout;
